import store from '@/lib/store'
import { Auth } from 'aws-amplify'
import { extendSessionByThreeHours } from '../contexts/transcription/src/store/modules/sessionExtender'

export async function getClientId() {
  if (!store.state.clientId) {
    try {
      const session = await Auth.currentSession()
      const payload = session.getIdToken().decodePayload()
      const clientId = payload?.['custom:client']
      store.commit('setClientId', clientId)
      extendSessionByThreeHours()

      return clientId
    } catch (e) {
      //eslint-disable-next-line
      console.error(JSON.stringify(e, null, 2))
    }
  }
  return store.state.clientId
}

export async function getUserCorrelation() {
  const session = await Auth.currentSession()
  const payload = session.getIdToken().decodePayload()
  const correlation = payload?.sub
  return correlation
}

export async function getUserEmail() {
  const session = await Auth.currentSession()
  const payload = session.getIdToken().decodePayload()
  const email = payload?.['custom:email'] ?? payload?.email
  return email
}
